$(document).ready(() => {

    // $('#brooklyn__curtain').addClass('active');
    // $('#header .row__header').addClass('in-viewport');
    // $('.section__hero .lp-hero__slide.first').addClass('in-viewport');
    // $('.anim-scale-down').parent().addClass('in-viewport');
    // $('.anim-slide-down').parent().addClass('in-viewport');
    // $('.from-right').parent().addClass('in-viewport');
    // $('.tda_up').parent().addClass('in-viewport');
});
